import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Query: ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "ms-2" }, "Sort by:", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", { value: "created" }, "Creation date", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: "comments" }, "Comment count", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "score" }, "Score", -1)
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "descending" }, "Descending", -1)
const _hoisted_9 = { class: "d-flex align-items-center mt-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Include:", -1)
const _hoisted_11 = ["value", "id"]
const _hoisted_12 = ["for"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createElementVNode("input", {
        class: "form-control flex-grow-1 ms-2",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.opts.query) = $event)),
        style: {"width":"unset"},
        onKeypress: _withKeys($setup.goSearch, ["enter"])
      }, null, 544), [
        [_vModelText, $setup.opts.query]
      ]),
      _hoisted_3,
      _withDirectives(_createElementVNode("select", {
        class: "ms-2",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.sortField) = $event))
      }, _hoisted_7, 512), [
        [_vModelSelect, $setup.sortField]
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "ms-2 me-1",
        id: "descending",
        type: "checkbox",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.sortDescending) = $event))
      }, null, 512), [
        [_vModelCheckbox, $setup.sortDescending]
      ]),
      _hoisted_8
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.SearchItemType, (val, name) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          _withDirectives(_createElementVNode("input", {
            class: "ms-2",
            type: "checkbox",
            value: val,
            id: val,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.opts.type) = $event))
          }, null, 8, _hoisted_11), [
            [_vModelCheckbox, $setup.opts.type]
          ]),
          _createElementVNode("label", {
            class: "ms-1",
            for: val
          }, _toDisplayString(name) + "s", 9, _hoisted_12)
        ], 64))
      }), 256)),
      _createVNode(_component_router_link, {
        class: "btn btn-primary ms-auto",
        to: $setup.searchUrl
      }, {
        default: _withCtx(() => [
          _createTextVNode("Search")
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}